import { getGridStringOperators } from '@mui/x-data-grid-pro';

export const getStringFilterOperators = getGridStringOperators().filter(
  (operator) => operator.value === 'contains' || operator.value === 'equals'
);
